export var AltsVerbiage;
(function (AltsVerbiage) {
    AltsVerbiage["race_alt"] = "race_alt";
    AltsVerbiage["gold_coin_alt"] = "gold_coin_alt";
    AltsVerbiage["world_alt"] = "world_alt";
    AltsVerbiage["races_banner_alt"] = "races_banner_alt";
    AltsVerbiage["races_banner_mobile_alt"] = "races_banner_mobile_alt";
    AltsVerbiage["vipclub_icon_alt"] = "vipclub_icon_alt";
    // UI elements
    AltsVerbiage["chip_button_image_alt"] = "chip_button_image_alt";
    AltsVerbiage["error_alt"] = "error_alt";
    AltsVerbiage["chest_alt"] = "chest_alt";
    AltsVerbiage["money_alt"] = "money_alt";
    AltsVerbiage["usdt_alt"] = "usdt_alt";
    AltsVerbiage["reward_alt"] = "reward_alt";
    AltsVerbiage["handle_icon_alt"] = "handle_icon_alt";
    AltsVerbiage["input_icon_alt"] = "input_icon_alt";
    AltsVerbiage["illustration_alt"] = "illustration_alt";
    AltsVerbiage["reward_icon_alt"] = "reward_icon_alt";
    AltsVerbiage["arrow_left_alt"] = "arrow_left_alt";
    AltsVerbiage["arrow_right_alt"] = "arrow_right_alt";
    AltsVerbiage["banner_background_alt"] = "banner_background_alt";
    AltsVerbiage["promo_alt"] = "promo_alt";
    AltsVerbiage["ellipse_alt"] = "ellipse_alt";
    AltsVerbiage["orange_alt"] = "orange_alt";
    AltsVerbiage["turnoff_alt"] = "turnoff_alt";
    AltsVerbiage["icon_alt"] = "icon_alt";
    AltsVerbiage["green_alt"] = "green_alt";
    AltsVerbiage["rollback_icon_alt"] = "rollback_icon_alt";
    AltsVerbiage["shape_top_alt"] = "shape_top_alt";
    AltsVerbiage["shape_bottom_alt"] = "shape_bottom_alt";
    AltsVerbiage["edit_alias_alt"] = "edit_alias_alt";
    AltsVerbiage["loading_alt"] = "loading_alt";
    AltsVerbiage["learn_more_img_alt"] = "learn_more_img_alt";
    AltsVerbiage["loading_mobile_alt"] = "loading_mobile_alt";
    AltsVerbiage["show_password_alt"] = "show_password_alt";
    AltsVerbiage["logo_alt"] = "logo_alt";
    AltsVerbiage["star_alt"] = "star_alt";
    AltsVerbiage["avatar_alt"] = "avatar_alt";
    AltsVerbiage["section_illustration_alt"] = "section_illustration_alt";
    AltsVerbiage["diamond_alt"] = "diamond_alt";
    AltsVerbiage["vip_icons_alt"] = "vip_icons_alt";
    AltsVerbiage["cards_left_alt"] = "cards_left_alt";
    AltsVerbiage["chests_alt"] = "chests_alt";
    AltsVerbiage["cards_right_alt"] = "cards_right_alt";
    AltsVerbiage["rakeboost_button_alt"] = "rakeboost_button_alt";
    AltsVerbiage["rakeboost_battery_alt"] = "rakeboost_battery_alt";
    AltsVerbiage["modal_header_alt"] = "modal_header_alt";
    AltsVerbiage["site_logo_alt"] = "site_logo_alt";
    AltsVerbiage["gold_coin_single_alt"] = "gold_coin_single_alt";
    AltsVerbiage["gold_coins_alt"] = "gold_coins_alt";
    AltsVerbiage["chest_and_gold_illustration_alt"] = "chest_and_gold_illustration_alt";
    AltsVerbiage["percentage_alt"] = "percentage_alt";
    // Crypto icons
    AltsVerbiage["arb_alt"] = "arb_alt";
    AltsVerbiage["base_alt"] = "base_alt";
    AltsVerbiage["lightning_alt"] = "lightning_alt";
    AltsVerbiage["optimism_alt"] = "optimism_alt";
    AltsVerbiage["avax_alt"] = "avax_alt";
    // Generic icons
    AltsVerbiage["wallet_icon_alt"] = "wallet_icon_alt";
    AltsVerbiage["x_icon_alt"] = "x_icon_alt";
    AltsVerbiage["dropdown_icon_alt"] = "dropdown_icon_alt";
    AltsVerbiage["warning_new_icon_alt"] = "warning_new_icon_alt";
    AltsVerbiage["originals_icon_alt"] = "originals_icon_alt";
    AltsVerbiage["question_icon_alt"] = "question_icon_alt";
    AltsVerbiage["up_icon_alt"] = "up_icon_alt";
    AltsVerbiage["warning_icon_alt"] = "warning_icon_alt";
    AltsVerbiage["search_icon_alt"] = "search_icon_alt";
    AltsVerbiage["reddit_icon_alt"] = "reddit_icon_alt";
    AltsVerbiage["free_spins_icon_alt"] = "free_spins_icon_alt";
    AltsVerbiage["popular_icon_alt"] = "popular_icon_alt";
    AltsVerbiage["events_tickets_icon_alt"] = "events_tickets_icon_alt";
    AltsVerbiage["vip_header_icon_alt"] = "vip_header_icon_alt";
    AltsVerbiage["trash_icon_alt"] = "trash_icon_alt";
    AltsVerbiage["testimonials_icon_alt"] = "testimonials_icon_alt";
    AltsVerbiage["lock_icon_alt"] = "lock_icon_alt";
    AltsVerbiage["sports_icon_alt"] = "sports_icon_alt";
    AltsVerbiage["recently_tab_icon_alt"] = "recently_tab_icon_alt";
    AltsVerbiage["arrow_icon_alt"] = "arrow_icon_alt";
    AltsVerbiage["support_icon_alt"] = "support_icon_alt";
    AltsVerbiage["wallet_game_icon_alt"] = "wallet_game_icon_alt";
    AltsVerbiage["info_icon_alt"] = "info_icon_alt";
    // Payment methods
    AltsVerbiage["chips_alt"] = "chips_alt";
    AltsVerbiage["visa_alt"] = "visa_alt";
    AltsVerbiage["gpay_alt"] = "gpay_alt";
    AltsVerbiage["mastercard_alt"] = "mastercard_alt";
    AltsVerbiage["apple_pay_alt"] = "apple_pay_alt";
    // VIP section
    AltsVerbiage["become_vip_alt"] = "become_vip_alt";
    AltsVerbiage["left_control_alt"] = "left_control_alt";
    AltsVerbiage["right_control_alt"] = "right_control_alt";
    AltsVerbiage["provider_logo_alt"] = "provider_logo_alt";
    // Banners & illustrations
    AltsVerbiage["crypto_banner_alt"] = "crypto_banner_alt";
    AltsVerbiage["spinner_alt"] = "spinner_alt";
    AltsVerbiage["reward_icon_image_alt"] = "reward_icon_image_alt";
    AltsVerbiage["join_now_alt"] = "join_now_alt";
    AltsVerbiage["banner_alt"] = "banner_alt";
    // Referral & rewards
    AltsVerbiage["referral_project_alt"] = "referral_project_alt";
    AltsVerbiage["coin_alt"] = "coin_alt";
    AltsVerbiage["coin_bg_alt"] = "coin_bg_alt";
    AltsVerbiage["moneybox_alt"] = "moneybox_alt";
    AltsVerbiage["box_alt"] = "box_alt";
    AltsVerbiage["hat_illustration_alt"] = "hat_illustration_alt";
    AltsVerbiage["how_it_works_illustration_alt"] = "how_it_works_illustration_alt";
    AltsVerbiage["invite_friends_banner_alt"] = "invite_friends_banner_alt";
    AltsVerbiage["top_arc_alt"] = "top_arc_alt";
    AltsVerbiage["bottom_arc_alt"] = "bottom_arc_alt";
    AltsVerbiage["unlock_alt"] = "unlock_alt";
    AltsVerbiage["card_background_alt"] = "card_background_alt";
    // Calendar & dates
    AltsVerbiage["calendar_icon_alt"] = "calendar_icon_alt";
    // Level & progression
    AltsVerbiage["level_up_alt"] = "level_up_alt";
    AltsVerbiage["tier_card_img_alt"] = "tier_card_img_alt";
    AltsVerbiage["person_alt"] = "person_alt";
    // Chat & media
    AltsVerbiage["selected_gif_alt"] = "selected_gif_alt";
    AltsVerbiage["close_icon_alt"] = "close_icon_alt";
    AltsVerbiage["message_icon_alt"] = "message_icon_alt";
    AltsVerbiage["option_user_icon_alt"] = "option_user_icon_alt";
    AltsVerbiage["selected_option_icon_alt"] = "selected_option_icon_alt";
    // Misc
    AltsVerbiage["hero_banner_alt"] = "hero_banner_alt";
    AltsVerbiage["meme_icon_alt"] = "meme_icon_alt";
    AltsVerbiage["first_page_alt"] = "first_page_alt";
    AltsVerbiage["last_page_alt"] = "last_page_alt";
    AltsVerbiage["no_transactions_illustration_alt"] = "no_transactions_illustration_alt";
    AltsVerbiage["coming_soon_banner_alt"] = "coming_soon_banner_alt";
    AltsVerbiage["maintenance_alt"] = "maintenance_alt";
    AltsVerbiage["geoblock_alert_alt"] = "geoblock_alert_alt";
    AltsVerbiage["welcome_modal_illustration_alt"] = "welcome_modal_illustration_alt";
    AltsVerbiage["deposit_bonus_alt"] = "deposit_bonus_alt";
    AltsVerbiage["section_icon_alt"] = "section_icon_alt";
    AltsVerbiage["step_image_alt"] = "step_image_alt";
})(AltsVerbiage || (AltsVerbiage = {}));
